import React from "react";
import { View, Text } from "react-native";

import { openTeleponeWindow, openWAURL } from "../../screens/CommonService";

import { CloseIcon } from "../widgets/Common-Widget";
import { CommonIconCTA } from "../widgets/CommonCTA";

import AppTheme from "../../AppTheme";
import Modal from 'react-native-modal';
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import Colors from "../constants/AppColors";

const SupportViewModal = (props) => {
    const showPopup = props.showPopup
    const hasBackdrop = props?.hasBackdrop ?? true
    const closeModal = props.closeModal
    return <Modal isVisible={showPopup}
        hasBackdrop={hasBackdrop}
        animationOut={"slideOutDown"}
        deviceHeight={AppTheme.modalHeight}
        backdropOpacity={AppTheme.modalBackdropOpacity}
        animationOutTiming={AppTheme.modalAnimationDuration}
        onBackdropPress={() => closeModal()}>
        <View style={AppStyles.modalContainer}>
            <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 28 }]}>
                <Text style={[TextStyle.text14b]}>Need help? Reach out to us</Text>
                <CloseIcon onPress={() => { closeModal() }} />
            </View>
            <View style={[AppStyles.flexRowSpaceBetween]}>
                <CommonIconCTA key={'Chat Support'}
                    title={'Chat'} titleColor={Colors.white}
                    width={(AppTheme.appWidth - 80) / 2}
                    iconSize={24} imageTextGap={8}
                    paddingVertical={12} borderRadius={48}
                    backgroundColor={Colors.green.whatsappColor}
                    iconPath={'/images/icons/whatsapp/white.svg'}
                    action={() => { openWAURL(); closeModal() }} />
                <CommonIconCTA key={'Call Support'}
                    title={'Call'} titleColor={Colors.white}
                    width={(AppTheme.appWidth - 80) / 2}
                    iconSize={24} imageTextGap={8}
                    paddingVertical={12} borderRadius={48}
                    backgroundColor={Colors.primary}
                    iconPath={'/images/icons/call/white.svg'}
                    action={() => { openTeleponeWindow(); closeModal() }} />
            </View>
        </View>
    </Modal >
}

export default SupportViewModal